import styled from '@emotion/styled';

export const ProductDetailContainer = styled.div`
  width: 100%;
  height: 100%;
`;
